import { useQueryClient } from '@tanstack/react-query';
import { useApplicationLocalStorage } from '../../application-hook';
import { ReckittApplicationParameters } from '@platform/client/schemas';
import { useState } from 'react';
import { ApplicationPageProps } from '../../Application';
import { Application, Cohorts } from '@platform/client';
import { CohortDetails } from '../../program/shared/CohortDetails';
import { ErrorBox } from '@platform/components';

export const ReckittConfirmAndSubmit = (props: ApplicationPageProps) => {
	const [failed, setFailed] = useState(false);
	const { getApplicationData } = useApplicationLocalStorage<ReckittApplicationParameters>(
		props.dataKey,
	);
	const { data: cohortData, isSuccess } = Cohorts.useGetCurrentUserCurrentCohort();
	const submitReckittMutation = Application.useSubmitReckittApplication();
	const queryClient = useQueryClient();

	const submit = () => {
		submitReckittMutation.mutate(
			{
				data: {
					...getApplicationData(),
				},
			},
			{
				onSuccess: () => {
					queryClient.invalidateQueries({
						queryKey: Application.getGetProfessionalApplicationStatusQueryKey(),
					});
				},
				onError: () => {
					setFailed(true);
				},
			},
		);
	};

	return (
		<>
			{isSuccess && cohortData && <CohortDetails {...props} cohortData={cohortData} onBack={props.onBack} onSubmit={submit} isSubmitting={submitReckittMutation.isPending || submitReckittMutation.isSuccess} />}
			{failed && (
				<ErrorBox showAlertTriangle={true}>
					There was an error submitting your application. Please try again later.
				</ErrorBox>
			)}
		</>
	);
};
